import { FilterBaseComponent } from "./filter-base-component.js";
import type { ColumnData,  ErogantiFilter } from "../../types/ListManagerTypes.js";
import { FILTER_OPERATORS, FilterOperator } from "../../constants/FilterConstants.js";
import { BonusEroganti } from "../bonus-eroganti/bonus-eroganti.js";

export class FilterErogantiComponent extends FilterBaseComponent {
    static webComponentName: string = "form-eroganti-filter";
    protected _templateId: string = 'filter-eroganti-template'; // Template ID for rendering

    // Supported operators for  filters (from centralized constants)
    private static readonly OPERATORS = FILTER_OPERATORS.eroganti;
    protected erogantiControl!: BonusEroganti;
    protected _operator: FilterOperator = '='; // Default operator

    get operator(): FilterOperator {
        return this._operator;
    }

    set operator(value: FilterOperator) {
        return; // No operator change allowed 
    }
    get filterValue(): any {
        if (!this.erogantiControl) {
            return [];
        }
        return this.erogantiControl ? this.erogantiControl.value : [];
    }
    /**
     * Generate ErogantiFilter object from current UI state
     */
    generateFilter(): ErogantiFilter {
        return {
            type: 'eroganti',
            columnName: this.fieldName,
            searchTerm: this.filterValue,
            operator: "="
        };
    }

    /**
     * Get available operators for  filter
     */
    getAvailableOperators(): string[] {
        return ['='];
    }

    /**
     * Validate filter value based on operator
     */
    validateFilterValue(): boolean {
        if (!this.erogantiControl) {
            return false;
        }

        const selectedValues = this.erogantiControl.value;
        return Array.isArray(selectedValues) && selectedValues.length > 0;
    }

    protected onPrepareData(data: Record<string, any>): Record<string, any> {
        // Override to add any additional data needed for template
        return {
            ...data,
            filterId: this.filterId,
        }
    }

    initialize(colData: ColumnData): void {
        super.initialize(colData);
    }

    protected afterRender() {
        this.erogantiControl = this.querySelector('bonus-eroganti') as BonusEroganti;
    }
    rendered: boolean = false;
    protected render(): void {
        if (this.rendered) {
            return;
        }
        super.render();
        this.rendered = true;
    }
    protected setupEventListeners(): void {
        if (this.erogantiControl) {
            // Ascoltare cambiamenti di valore dal componente figlio
            this.erogantiControl.addEventListener('eroganti-value-changed', (e: Event) => {
                // this.dispatchFilterEvent("change"); // se esiste
                this.dispatchValueChange(); // nuovo standard
            });
        }
    }
}   